import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractProductCategory from "../ProductCategory";

class ProductCategory extends AbstractProductCategory {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-category-ipr';
  }
}

export default ProductCategory;
